"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenStorage = void 0;
const tslib_1 = require("tslib");
const global_object_1 = tslib_1.__importDefault(require("./global-object"));
const store = (_a = global_object_1.default.localStorage) !== null && _a !== void 0 ? _a : {};
const DEFAULT_TOKEN_KEY = 'uxa:jwt';
class TokenStorage {
    static store(token) {
        store[TokenStorage.getKey()] = token;
        TokenStorage.callbacks.forEach((i) => i(token));
    }
    static getVersion() {
        return TokenStorage.version;
    }
    static setKey(key) {
        TokenStorage.key = key;
    }
    static get() {
        return store[TokenStorage.getKey()];
    }
    static onTokenRefreshed(callback) {
        TokenStorage.callbacks.push(callback);
    }
    static getKey() {
        var _a;
        return (_a = TokenStorage.key) !== null && _a !== void 0 ? _a : DEFAULT_TOKEN_KEY;
    }
}
exports.TokenStorage = TokenStorage;
TokenStorage.callbacks = [];
//# sourceMappingURL=token.storage.js.map